import { motion, useReducedMotion } from "motion/react";
import { Button, Icon } from "@project/ui";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";

export interface ErrorStateProps {
  onRetry?: () => void;
}

export function ErrorState({ onRetry }: ErrorStateProps): JSX.Element {
  const { t } = useI18n();
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      className="flex min-h-[12rem] flex-col items-center justify-center gap-3 rounded-xl bg-error/5 px-6 py-12 text-center outline outline-1 outline-error/15"
      initial={prefersReducedMotion ? undefined : { opacity: 0, y: 6 }}
      animate={prefersReducedMotion ? undefined : { opacity: 1, y: 0 }}
      transition={prefersReducedMotion ? undefined : { duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
    >
      <Icon name="CircleAlert" className="size-10 text-error" strokeWidth={1.5} />
      <p className="font-headline text-headline-sm font-bold text-primary">{t("dashboardUi.states.errorTitle")}</p>
      <p className="max-w-sm font-body text-body-md text-on-surface-variant">{t("dashboardUi.states.errorHint")}</p>
      {onRetry ? (
        <Button type="button" variant="outline" onClick={onRetry} className="mt-2">
          <Icon name="RefreshCw" size={16} className="mr-2" strokeWidth={1.5} />
          {t("dashboardUi.states.retry")}
        </Button>
      ) : null}
    </motion.div>
  );
}
